import {
  TerminPouzitieVPredpisochUpdateApi,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import PouzitiePredpis from '../../model/PouzitiePredpis';

const client = new TerminPouzitieVPredpisochUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTerminPouzitieVPredpisoch = async (
  terminUuid: Uuid,
  pouzitiePredpisList: Array<PouzitiePredpis>,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { data, status } = await client.updateTerminPouzitieVPredpisoch(terminUuid, pouzitiePredpisList, options);
  return { data, responseCode: status };
};
